import React, { useState, useEffect, useContext } from "react";

import MainButton from "../../common/MainButton";
import MainTitle from "../../common/MainTitle";
import TableMainSearch from "../../common/MainSearch";

import { YearContext } from "../../../contexts/yearContext";
import { PopUpContext } from "../../../contexts/popUpContext";

import DataTable from "./StudentsList";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import MainPrintLink from "../../common/MainPrint";

const Classes = ({ match }) => {
  const { cid } = match.params;

  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");
  const { entryYear } = useContext(YearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  useEffect(() => {
    const ac = new AbortController();
    requestData();
    return () => ac.abort();
  }, [entryYear, popUp, cid]);

  const requestData = async () => {
    try {
      await db.getAll(`classes/${cid}/students`).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  const openAddStudent = () => {
    togglePopUp({
      form: "student-to-class",
      classLocked: true,
      classId: Number(cid),
      classDesc: data?.summary?.class_desc || "",
      entryYear: data?.summary?.entry_year_id || entryYear,
      callback: () => requestData(),
    });
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton type="back" />
          <MainTitle title={data?.summary?.class_desc} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainButton
            type="add"
            title={lbl.AddStudentToClass || "اضافه نمودن به صنف"}
            handleClick={openAddStudent}
          />
          <MainPrintLink path={`classes/${cid}/students`} />
        </div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} query={query} />
      </div>
    </div>
  );
};

export default Classes;
